<!--
 * @Author: Gaho
 * @Date: 2024-05-07 11:05:50
 * @LastEditors: Gaho
 * @LastEditTime: 2024-11-29 11:00:21
 * @Description: 
-->
<template>
    <div class="coinflip-game-row-body">
        <div class="game-area">
            <div class="game-label">
                <div>{{ $t('series') }}</div>
                <div>{{ roundData.series }}</div>
            </div>
            <div class="game-coin">
                <p v-show="!showMultiAnimation" class="game-result" :class="resultCss.class">
                    {{ resultCss.text && $t(resultCss.text) }}
                </p>
                <div id="coin" :class="animationClass">
                    <div class="coin-head"></div>
                    <div class="coin-tail"></div>
                </div>
            </div>
            <!-- 
                ↑ 中间硬币
                ↓ 右侧倍数信息 
            -->
            <div class="game-label">
                <div>{{ $t('multiplier') }}</div>
                <div class="leading-8 text-2xl relative">
                    x{{ getFixed(roundData.odds) }}
                    <div v-show="showMultiAnimation" :class="showMultiAnimation">
                        x{{ getFixed(roundData.odds) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'betBoard',
    props: {
        roundData: {
            type: Object,
            default: () => ({}),
        },
        showMultiAnimation: {
            type: String,
            default: '',
        },
        animationClass: {
            type: String,
            default: '',
        },
        resultCss: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style lang="scss" scoped>
.coinflip-game-row-body {
    align-items: center;
    display: flex;
    min-height: 200px;
    padding: 25px;
    background: #161f2c;
    @media (max-width: 1100px) {
        min-height: 200px;
        padding-left: 10px;
        padding-right: 10px;
    }
    .game-area {
        display: flex;
        position: relative;
        width: 100%;
        .game-label {
            align-items: center;
            background-color: #283343;
            display: flex;
            flex-direction: column;
            justify-content: center;
            min-height: 100px;
            width: 50%;

            &:first-of-type {
                border-radius: 100px 0 0 100px;
                padding-right: 50px;
            }

            &:last-of-type {
                border-radius: 0 100px 100px 0;
                padding-left: 50px;
            }
            > div {
                &:first-child {
                    color: #55657e;
                    font-size: 12px;
                    font-weight: 500;
                    line-height: 1;
                    margin-bottom: 15px;
                    text-transform: uppercase;
                }
                &:last-child {
                    color: #55657e;
                    font-size: 24px;
                    font-weight: 700;
                    line-height: 1;
                    transition: color 0.3s;
                }
                @media (max-width: 1100px) {
                    &:first-child {
                        font-size: 10px;
                    }
                    &:last-child {
                        font-size: 16px;
                    }
                }
            }
        }

        @media (max-width: 1100px) {
            .game-label {
                min-height: 80px;
            }
        }
        .game-coin {
            display: block;
            height: 140px;
            left: 50%;
            perspective: 400px;
            position: absolute;
            top: 50%;
            transform: translate(-50%, -50%);
            transform-style: preserve-3d;
            transition: opacity 0.3s;
            width: 140px;
            z-index: 1;

            .game-result {
                animation-direction: normal;
                animation-duration: 0.7s;
                animation-timing-function: ease-out;
                color: #62ca5b;
                font-size: 22px;
                font-weight: 900;
                left: 0;
                line-height: 1;
                opacity: 0;
                position: absolute;
                right: 0;
                text-align: center;
                text-transform: uppercase;
            }

            .result-win {
                color: #227943;
                top: -22px;
                animation-name: resultWin;
            }
            .result-win-fast {
                color: #227943;
                top: -22px;
                opacity: 1;
            }
            .result-lose {
                bottom: -22px;
                color: #e86376;
                animation-name: resultLose;
            }
            .result-lose-fast {
                bottom: -22px;
                color: #e86376;
                opacity: 1;
            }
            #coin {
                height: 100%;
                perspective: 400px;
                position: relative;
                width: 100%;
                backface-visibility: hidden;
                transform-style: preserve-3d;
            }
        }
        .coin-head {
            background-image: url('@/assets/webp/coin-head.webp');
            background-size: cover;
            width: 100%;
            height: 100%;
            position: absolute;
            backface-visibility: hidden;
            transform-style: preserve-3d;
        }
        .coin-tail {
            background-image: url('@/assets/webp/coin-tail.webp');
            background-size: cover;
            width: 100%;
            height: 100%;
            position: absolute;
            backface-visibility: hidden;
            transform-style: preserve-3d;
        }

        .coin-tail-show {
            transform: translateZ(1px) rotateX(180deg);
        }

        .coin-head-show {
            transform: translateZ(-1px);
        }
        .coin-result-back .coin-head,
        .coin-result-back .coin-tail,
        .coin-result-front .coin-head,
        .coin-result-front .coin-tail {
            transform: translateZ(-1px) rotateX(180deg);
        }
        .coin-result-front {
            .coin-head {
                transform: translateZ(1px);
            }
            .coin-tail {
                transform: translateZ(-1px) rotateX(180deg);
            }
        }
        .coin-result-back {
            .coin-head {
                transform: translateZ(-1px) rotateX(180deg);
            }
            .coin-tail {
                transform: translateZ(1px);
            }
        }
        @media (max-width: 1100px) {
            .game-coin {
                height: 120px;
                width: 120px;
            }
        }
    }
}

.multi-animation {
	animation-direction: normal;
    animation-duration: .7s;
    animation-name: balance;
    animation-timing-function: ease-out;
    bottom: 0;
    color: #62ca5b;
    font-size: inherit;
    font-weight: inherit;
    left: 0;
    opacity: 0;
    position: absolute;
    white-space: nowrap;
    width: 100%;
}
.multi-animation-lose {
	animation-direction: reverse;
	color: #e86376;
}
@keyframes balance {
	0% {
		transform: translateY(100%);
		opacity: 0;
	}
	50% {
		opacity: 1;
	}
	to {
		transform: translateY(0%);
		opacity: 0;
	}
}
@keyframes resultWin {
    0% {
        opacity: 0;
        transform: translateY(0);
    }

    50% {
        opacity: 1;
    }

    to {
        opacity: 0;
        transform: translateY(-100%);
    }
}
@keyframes resultLose {
    0% {
        opacity: 0;
        transform: translateY(0);
    }

    50% {
        opacity: 1;
    }

    to {
        opacity: 0;
        transform: translateY(100%);
    }
}
</style>